'use client'
import { CookieDetailModal } from '@/components/layout/cookie/detail'
import { TrackCookieSection, TrackerProvider, TrackExposure, TrackPageType } from 'modules/analysis'
import { getDefaultCookieSettings, useCookieSetting } from 'modules/client'
import { CookieIcon } from 'modules/components'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'

const FixedCookie = dynamic(() => import('@/components/layout/cookie/fixed'), { ssr: false })

export function CookiePage() {
  const [setting, setSetting] = useCookieSetting()
  const [detail, openDetail] = useState(false)
  const [delay, setDelay] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDelay(false)
    }, 1500)

    return () => {
      clearTimeout(timer)
    }
  }, [])

  if (delay) {
    return null
  }

  return (
    <TrackerProvider config={{ pageType: TrackPageType.Cookie }}>
      <div className="fixed bottom-0 left-0 z-20">
        {setting.length ? (
          detail ? (
            <CookieDetailModal
              defaultValue={setting}
              onClose={(val) => {
                if (val?.length) {
                  setSetting(val)
                }
                openDetail(false)
              }}
            />
          ) : (
            <TrackExposure config={{ sectionName: TrackCookieSection.FixedIcon }} withClick>
              <div>
                <CookieIcon
                  onClick={() => {
                    openDetail(true)
                  }}
                />
              </div>
            </TrackExposure>
          )
        ) : (
          <FixedCookie
            onClose={(isAccept) => {
              setSetting(getDefaultCookieSettings(isAccept))
            }}
          />
        )}
      </div>
    </TrackerProvider>
  )
}
